import React from "react";

export const Menu: React.FunctionComponent = ({ children }) => {
  return <ul>{children}</ul>;
};
